// extracted by mini-css-extract-plugin
export default {"bottomSheet":"cookie-consent-CookieConsentModal-bottomSheet-d08ec30b","popUpWindow":"cookie-consent-CookieConsentModal-popUpWindow-848df617"};